import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const RazonSocialFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='RAZ SOC' htmlFor='select-razonSocial' md={1} />
      <Col md={11}>
        <Field name='razonSocial'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-razonSocial'
              placeholder='Ingresar razón social ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(RazonSocialFormGroup)
